<template>
    <div v-if="loading == false">
        <ChirpList
            :data_source="rows"
            :export_api="export_api"
            :totalCount="totalCount"
            :target_page="targetPage"
            @applyCriteria="modifyCriteria"
            :loadingColumns="loadingTable"
            :column_meta="columnMeta"
            :storeKey="storeKey"
            :useOverride="useOverride"
            @cancelOverride="handleCancelOverride"
        />
    </div>
    <div v-else>Loading...</div>
</template>

<script>
    import { tryGetFilter } from '@/util/tryGetFilter';

    const api_root = 'insurance/list_eras';

    import ChirpList from '@/components/general/list/ChirpList';

    export default {
        name: 'InsuranceERAs',
        components: { ChirpList },
        props: {
            overrideFilter: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                rows: [],
                totalCount: 0,
                targetPage: 'InsuranceERADetail',
                loading: true,
                loadingTable: false,
                useOverride: false,
                criteriaProps: {},
                export_api: '/insurance/list_eras',
                columnMeta: [
                    // { field: 'client', headerText: 'Client' }, = there are MULTIPLE clients in a single era
                    { field: 'era_id', headerText: 'ERA ID' },
                    { field: 'create_date', headerText: 'Create Date' },
                    { field: 'paid_date', headerText: 'Paid Date' },
                    { field: 'payer', headerText: 'Payer' },
                    { field: 'icn', headerText: 'Payer ICN' },
                    { field: 'paid_amount', headerText: 'Amount Paid', align: 'Right' },
                    { field: 'total_charge', headerText: 'Total Charge', align: 'Right' },
                    { field: 'service_date', headerText: 'Service Date', hide:1 },
                    { field: 'api_response_json', headerText: 'Api Response Json', hide:1 },
                ],

                /*
Client ERA ID	Paid Date		Payer	Payer ICN	Service Date	Services Associated (CPT) 	Total Charge	Amount Paid
 */
            };
        },
        computed: {
            criteria() {
                return this.useOverride && this.overrideFilter ? this.overrideCriteria : this.savedCriteria;
            },
            savedCriteria() {
                return tryGetFilter(this.$store, this.storeKey);
            },
            overrideCriteria() {
                return this.$store.getters['filters/overrideCriteria'](this.storeKey);
            },
            storeKey() {
                return this.pageMeta?.page || 'insurance-eras';
            },
        },
        methods: {
            async load_data() {
                try {
                    const body = {
                        criteria: this.criteria
                    };
                    const res = await this.$api.post(this.export_api, body);

                    if (res.status >= 400) {
                        this.$toasted.error('Failed to fetch insurance ERA roster.');
                        return;
                    }

                    this.rows = res.data.rows;

                    this.totalCount = res.data.total_count;
                } catch (err) {
                    this.$toasted.error('Failed to fetch insurance ERA roster.');
                }
                this.$nextTick(() => {
                    this.loading = false;
                });
            },
            async init() {
                if (this.overrideFilter) {
                    this.useOverride = true;
                    this.$store.commit('filters/applyOverride', {
                        stateKey: this.storeKey,
                        criteria: this.overrideFilter,
                    });
                }

                if (!this.criteria.sort || (this.criteria.sort && Object.keys(this.criteria.sort).length === 0)) {
                    this.$store.commit('filters/applyDefaultDateSort', {
                        stateKey: this.storeKey,
                        customDateKey: 'paid_date',
                    });
                }

                await this.load_data();
            },
            async modifyCriteria(criteria) {
                if (this.targetPage) {
                    this.$store.commit('filters/update', {
                        criteriaPage: this.targetPage,
                        payload: criteria,
                    });
                }
                this.criteriaProps = criteria;
                this.load_data();
            },
            handleCancelOverride() {
                this.useOverride = false;
            },
        },
        watch: {
            criteria: {
                deep: true,
                async handler() {
                    await this.load_data();
                },
            },
        },
        async created() {
            await this.init();
        },
    };
</script>
